import parseUrlQueryString from 'services/parseUrlQueryString/parseUrlQueryString';
import { ConsentReferralUrlParams } from '../../types';
import { ConsentHubConsentRequest } from '../../../../services/api';

const requireString = (value: unknown): string | undefined =>
  value != null && (typeof value === 'string' || typeof value === 'number') ? `${value}` : undefined;

const createConsents = (grant: Record<string, string> | undefined, revoke: Record<string, string> | undefined) => {
  let consents: ConsentHubConsentRequest[] = [];

  consents = consents.concat(setConsentStates(grant, true));
  consents = consents.concat(setConsentStates(revoke, false));

  return consents;
};

const setConsentStates = (
  source: Record<string, string> | undefined,
  targetState: boolean,
): ConsentHubConsentRequest[] => {
  const consents: ConsentHubConsentRequest[] = [];

  if (source == null) return consents;

  Object.keys(source).forEach((key) => {
    consents.push({
      key,
      granted: targetState,
      displayedText: source[key],
    });
  });

  return consents;
};

const createSubscriptions = (subscribe: string | undefined) => {
  const value = requireString(subscribe);
  if (!value) return undefined;
  return value.split(',').map((item) => ({ key: item, subscribed: true }));
};

export const parseConsentQuery = (query: string): Partial<ConsentReferralUrlParams> => {
  const { hid, site, formUrl, subscribe, grant, action, source, revoke } = parseUrlQueryString(query);

  return {
    hid: requireString(hid),
    site: requireString(site),
    formUrl: requireString(formUrl),
    action: requireString(action),
    source: requireString(source),
    consents: createConsents(grant as Record<string, string>, revoke as Record<string, string>),
    subscriptions: createSubscriptions(subscribe as string),
  };
};
